module.exports = __webpack_public_path__ + "img/9_61.12a03d9c.png";